import Vue from 'vue'

export default {
  CLEAR_ALL (state) {
    for (const prop of Object.keys(state)) {
      if (prop !== 'mapEditable') Vue.set(state, prop, null)
    }
  },
  SET_ENTITY (state, entity) {
    Vue.set(state, entity.name, entity.entity)
  },
  SET_INCIDENCIA (state, incidencia) {
    state.incidencia = incidencia
  },
  SET_INSTALACION (state, instalacion) {
    state.idInstalacion = instalacion
  },
  SET_CLIENTE (state, cliente) {
    state.idCliente = cliente
  }
}
